import {BrandBase} from '../BrandBase';
import {createMicrositeTheme} from '../MicrositeTheme';

export const hardBase: BrandBase = {
  id: `hard`,
  domain: `hārd.com`,
  email: `support@hārd.com`,
  theme: `black`,
  backgroundId: `dynamic`,
  adsenseId: null,
  micrositeTheme: createMicrositeTheme({
    id: `hard`,
    name: `Hārd Microsite`,
    palette: {
      primary: `#dc2626`,
      secondary: `#1f1f1f`,
      accent: `#f87171`,
    },
    gradients: {
      hero: `linear-gradient(135deg, #1f1f1f, #dc2626)`,
      sectionLight: `linear-gradient(135deg, rgba(249, 250, 251, 0.96), rgba(243, 244, 246, 0.92))`,
      sectionDark: `linear-gradient(160deg, #050505, #1a0909 45%, #0c0202 90%)`,
      primaryCta: `linear-gradient(120deg, #dc2626, #ef4444 50%, #f97316 100%)`,
    },
    ctas: {
      primary: {
        background: `linear-gradient(120deg, #dc2626, #ef4444 50%, #f97316 100%)`,
        glow: `rgba(220, 38, 38, 0.45)`,
        shadow: `0 32px 70px rgba(220, 38, 38, 0.4)`,
      },
    },
  }),
  hostRedirects: {
    'www.xn--hrd-1oa.com': `xn--hrd-1oa.com`,
  },
  manifest: {
    name: `Hārd - Adult Sexting Chat | Anonymous & Private`,
    short_name: `Hārd`,
    description: `Adult sexting chat rooms. Anonymous intimate conversations, private messaging with complete discretion and encryption.`,
    theme_color: `#000000`,
    background_color: `#000000`,
    display: `standalone`,
    orientation: `portrait`,
    scope: `/`,
    start_url: `/`,
    icons: [],
  },
  canonical: {
    prod: `https://xn--hrd-1oa.com`,
    uat: `https://dev.xn--hrd-1oa.com`,
    local: `http://localhost:5173`,
    localdev: `http://localhost:5173`,
    localnative: `http://localhost:5173`,
  },
  favicon: `/logo-square.png`,
  seo: {
    keywords: `sexting chat, adult chat rooms, anonymous sexting, intimate messaging, private adult chat, sexual conversations, discreet messaging, adult dating chat, erotic chat`,
    author: `Hārd`,
  },
  social: {
    title: `Hārd - Adult Sexting Chat | Private & Anonymous`,
    image: `/icon.png`,
  },
};
